import SectionHeading from "./SectionHeading";
import { seriesList } from "@/mocks/catalog";

export default function Series() {
  return (
    <section id="series" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-content px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="系列说明"
              title="系列与单部作品的区别：条目之间有承接关系"
              desc="如果说单部作品是独立的一段，系列就是把若干段按同一主题串起来。理解这一点，能帮你在浏览时决定是按顺序看，还是随手挑。"
            />
            <div className="mt-6 rounded-lg border border-background-200/70 bg-secondary-100/70 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
                <i className="ri-information-line text-lg text-primary-600"></i>
                浏览系列时的两个小建议
              </h3>
              <ul className="mt-3 flex flex-col gap-2 text-sm leading-relaxed text-foreground-600">
                <li className="flex gap-2">
                  <i className="ri-arrow-right-s-line mt-0.5 text-accent-600"></i>
                  有编号的系列建议按顺序看，前面的内容常为后面做铺垫。
                </li>
                <li className="flex gap-2">
                  <i className="ri-arrow-right-s-line mt-0.5 text-accent-600"></i>
                  场景设定的系列可以跳着看，方便直接对比同一设定下的处理差异。
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ol className="flex flex-col gap-3">
              {seriesList.map((series, index) => (
                <li
                  key={series.id}
                  className="group flex items-start gap-4 rounded-lg border border-background-200/70 bg-background-100 p-4 transition-colors hover:border-primary-300 md:p-5"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-background-50 font-heading text-lg font-semibold text-primary-600">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="font-heading text-base font-semibold text-foreground-950">{series.name}</h3>
                      <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                        <i className="ri-time-line"></i>
                        {series.freq}
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{series.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}